import { render, staticRenderFns } from "./FrameWoodSelector.vue?vue&type=template&id=63a7d91b&scoped=true&"
import script from "./FrameWoodSelector.vue?vue&type=script&lang=ts&"
export * from "./FrameWoodSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FrameWoodSelector.vue?vue&type=style&index=0&id=63a7d91b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a7d91b",
  null
  
)

export default component.exports